var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgCardDetailBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 238,
    viewBox: "0 0 225 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.582375,
    width: 217,
    height: 189.563,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35_479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 217,
    height: 229,
    rx: 10,
    fill: "url(#paint0_linear_35_479)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 42,
    width: 216,
    height: 185
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 216,
    height: 185,
    rx: 10,
    fill: "url(#paint1_linear_35_479)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_479)"
  }, /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    x1: 27.1759,
    y1: 209.121,
    x2: 10.1207,
    y2: 227.052,
    stroke: "#1C6CC8",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_35_479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 217,
    height: 189
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 217,
    height: 189,
    rx: 10,
    fill: "url(#paint2_linear_35_479)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_35_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24C32.5 31.5 13 34.5 13 34.5L-6 38L2.5 -16L82 -18L83.9753 -1.70417C84.3507 -1.98576 84.3808 -1.9443 84 -1.50003L83.9753 -1.70417C81.3926 0.232615 62.469 17.452 48.5 24Z",
    fill: "#0B6EE3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_35_479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 41,
    width: 217,
    height: 189
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 230,
    width: 217,
    height: 189,
    rx: 10,
    transform: "rotate(-180 221 230)",
    fill: "url(#paint3_linear_35_479)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_35_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.5 207C192.5 199.5 212 196.5 212 196.5L231 193L222.5 247L143 249L141.025 232.704C140.649 232.986 140.619 232.944 141 232.5L141.025 232.704C143.607 230.767 162.531 213.548 176.5 207Z",
    fill: "#0B6EE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35_479",
    x: 0,
    y: 1,
    width: 225,
    height: 237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35_479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_479",
    x1: 16.5,
    y1: 206.373,
    x2: 208.906,
    y2: 114.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#489CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_479",
    x1: 31.3733,
    y1: 187.357,
    x2: 188.286,
    y2: 71.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#489CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0578FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_479",
    x1: 31.5,
    y1: 149.5,
    x2: 191,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#489CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0578FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_479",
    x1: 248.5,
    y1: 378.5,
    x2: 408,
    y2: 262.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#489CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0576FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCardDetailBlue);
export default __webpack_public_path__ + "static/media/bgCardDetailBlue.b3160cb7962604941e8fe6730cf004b7.svg";
export { ForwardRef as ReactComponent };